export const FLOW_NAMES = {
    LONG_PREQUAL: 'long_prequal',
    TWO_STEP_PREQUAL: 'two_step',
    LEAD_FIRST: 'lead_first',
};
